export const PERMANENT_DENTITION_RANGE_START = 1;
export const PERMANENT_DENTITION_RANGE_END = 32;
export const PRIMARY_DENTITION_RANGE_START = 1;
export const PRIMARY_DENTITION_RANGE_END = 20;
export const DENTITION_SYSTEM = 'universal';

export const MESIAL = 'mesial';
export const DISTAL = 'distal';
export const RBL_SIDES = [MESIAL, DISTAL];
export const IMAGE_TYPE_BITEWING = 'bitewing';
export const IMAGE_TYPE_PERIAPICAL = 'periapical';
export const IMAGE_TYPES = [IMAGE_TYPE_BITEWING, IMAGE_TYPE_PERIAPICAL];
export const RBL_LEVELS = {
  WHITE: 'white',
  GREEN: 'green',
  YELLOW: 'yellow',
  ORANGE: 'orange',
  RED: 'red',
};

export const PRIMARY_DENTITION = {
  name: 'primary',
  rangeStart: PRIMARY_DENTITION_RANGE_START,
  rangeEnd: PRIMARY_DENTITION_RANGE_END,
  numberingSystem: DENTITION_SYSTEM,
};
export const PERMANENT_DENTITION = {
  name: 'permanent',
  rangeStart: PERMANENT_DENTITION_RANGE_START,
  rangeEnd: PERMANENT_DENTITION_RANGE_END,
  numberingSystem: DENTITION_SYSTEM,
};
export const DENTITION_PERMANENT = 'permanent';
export const DENTITION_PRIMARY = 'primary';
export const DENTITION_MIXED = 'mixed';

export const allDentition = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
];

export const mixedDentitionMap = [
  { primaryTooth: '', permanentTooth: '1' },
  { primaryTooth: '', permanentTooth: '2' },
  { primaryTooth: '', permanentTooth: '3' },
  { primaryTooth: 'A', permanentTooth: '4' },
  { primaryTooth: 'B', permanentTooth: '5' },
  { primaryTooth: 'C', permanentTooth: '6' },
  { primaryTooth: 'D', permanentTooth: '7' },
  { primaryTooth: 'E', permanentTooth: '8' },
  { primaryTooth: 'F', permanentTooth: '9' },
  { primaryTooth: 'G', permanentTooth: '10' },
  { primaryTooth: 'H', permanentTooth: '11' },
  { primaryTooth: 'I', permanentTooth: '12' },
  { primaryTooth: 'J', permanentTooth: '13' },
  { primaryTooth: '', permanentTooth: '14' },
  { primaryTooth: '', permanentTooth: '15' },
  { primaryTooth: '', permanentTooth: '16' },
  { primaryTooth: '', permanentTooth: '17' },
  { primaryTooth: '', permanentTooth: '18' },
  { primaryTooth: '', permanentTooth: '19' },
  { primaryTooth: 'K', permanentTooth: '20' },
  { primaryTooth: 'L', permanentTooth: '21' },
  { primaryTooth: 'M', permanentTooth: '22' },
  { primaryTooth: 'N', permanentTooth: '23' },
  { primaryTooth: 'O', permanentTooth: '24' },
  { primaryTooth: 'P', permanentTooth: '25' },
  { primaryTooth: 'Q', permanentTooth: '26' },
  { primaryTooth: 'R', permanentTooth: '27' },
  { primaryTooth: 'S', permanentTooth: '28' },
  { primaryTooth: 'T', permanentTooth: '29' },
  { primaryTooth: '', permanentTooth: '30' },
  { primaryTooth: '', permanentTooth: '31' },
  { primaryTooth: '', permanentTooth: '32' },
];

export const DEFAULT_ODONTOGRAM_TIP = 'Select a tooth to view findings';
